import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { IStatusPanelParams } from "ag-grid-community";

interface Props extends IStatusPanelParams {
	onNewClip: () => void;
}

export const NewClipStatusBar = ({ onNewClip }: Props) => {
	return (
		<Button
			variant="contained"
			color="primary"
			size="small"
			startIcon={<AddIcon />}
			onClick={onNewClip}
			sx={{
				textTransform: "none",
				margin: "4px 8px",
			}}
		>
			NEW CLIP
		</Button>
	);
};
